export default __webpack_public_path__ + "static/media/learnN.0662dd3b.jpg";